// eslint-disable-next-line no-shadow
export var CookieReadConfigEnum;
(function (CookieReadConfigEnum) {
    CookieReadConfigEnum[CookieReadConfigEnum["COOKIE_READ_DEFAULT"] = 0] = "COOKIE_READ_DEFAULT";
    CookieReadConfigEnum[CookieReadConfigEnum["COOKIE_READ_TEA_PRIOR"] = 1] = "COOKIE_READ_TEA_PRIOR";
    // COOKIE_READ_LOCALSTORAGE_PRIOR = 1,
})(CookieReadConfigEnum || (CookieReadConfigEnum = {}));
